import { FunctionComponent, useCallback } from "react";
import "./LandingPage.scss";
import { useNavigate } from "react-router-dom";
import images from "../../assets/images";
import { getScreenDimensions } from "../../utils/helper";
import { useAppSelector } from "../../redux/app/hooks";
import { trackButtonClick } from "../../firebase/analyticsHelper";
import { ButtonClickEvents } from "../../firebase/constants/events";

const LandingPage: FunctionComponent = () => {
  const navigate = useNavigate();
  const {landingPageImage} = images;
  const { isMobileScreen } = getScreenDimensions();
  const { loginAs } = useAppSelector((state) => state.auth);
  const loginButtonOrder: string[] = ["student", "teacher", "pta", "schooladmin"];
  const loginText: Record<string, { label: string, link: string }> = {
    student: {label: "Student", link: "/student-signup"}, 
    teacher: {label: "Teacher", link: "/teacher-login"},
    pta: {label: "PTA", link: "/pta-verifyCode"},
    schooladmin: {label: "School Admin", link: "/admin-login"}
  };
  const displayButtons = loginButtonOrder?.filter((val: string) => val !== loginAs);

  //navigate to student signup page
  const onButtonClick = useCallback((link: string)=> {
    trackButtonClick(ButtonClickEvents?.JOIN_CLASSROOM_AS_STUDENT_CLICK, {
        description : `User clicked the Join Classroom as Student button`,
        page: 'Landing Page'
    });
    navigate(link);
  } , []);

  const landingImage = () => (
    <div className="bnrImg">
      <img className="rightImgIcon" alt="bannerImage" src={landingPageImage} data-testid="rightSideImage"/>
    </div>
  );

  return (
    <section className="sectionBanner">
      <div className="landingPagecontainer">
        <div className="leftSet">
          <div className="content">
            <div className="mainText">
              <p className="katon360Classroom">Katon 360 Classroom</p>
              <h1 className="teachSmartLearnContainer">
                <p className="teachSmart">{`TEACH SMART, `}</p>
                <p className="teachSmart">LEARN EASY.</p>
              </h1>
            </div>
            <p className="welcomeToThe">
            Welcome to the 360 Classroom where Teachers, Students and Parents meet to continue the traditional classroom activities.
            </p>
          </div>
          {isMobileScreen && landingImage()}
          <div className="buttonContainer">
            <button className={`heroCta`} onClick={() => onButtonClick(isMobileScreen ? loginText?.[loginAs]?.link : "/student-signup")}>
              <span className="joinClassroomAs">
                {`Join Classroom as ${ isMobileScreen ? loginText?.[loginAs]?.label : "Student" }`}
              </span>
            </button>
            <div className="loginAscontainerMobile">
              <div className="loginAsInnerContainer">
                <div className="loginAsBorder"></div>
                <div className="loginAsText">Or login as</div>
                <div className="loginAsBorder"></div>
              </div>
              <div className="secondryButtonContainer">
                <button className={`heroCta heroCtaInactive`} onClick={() => onButtonClick(loginText?.[displayButtons?.[0]]?.link)}>
                  <span className="joinClassroomAs">
                    {loginText?.[displayButtons?.[0]]?.label}
                  </span>
                </button>
              </div>
              <div className="secondryButtonContainer otherLoginButtonContainer">
                {
                  displayButtons?.slice(1)?.map((value: string) => (
                    <button className={`heroCta heroCtaInactive`} onClick={() => onButtonClick(loginText?.[value]?.link)}>
                      <span className="joinClassroomAs">
                        {loginText?.[value]?.label}
                      </span>
                    </button>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
        {!isMobileScreen && landingImage()}
      </div>
    </section>
  )
};

export default LandingPage;
